<template lang="html">
  <div v-if="data" class="row content"> 
    <div class="col-3" style="margin-top: 20px">
      <b-list-group v-for="(step, index) in data.steps" :key="index" >
        <b-list-group-item href="#" :active="activeMenu2(index)" class="borderMenu" @click="changeStepMenu(index)">
          <b-row>
          <b-col cols="9">{{step.name}}</b-col>
          <b-col>
             <b-badge variant="success" pill class="pull-right" v-if="step.responses === step.questions.length"><font-awesome-icon icon="check-circle" :style="{ color: 'white' }" size="lg" /></b-badge>
            <b-badge variant="primary" pill class="pull-right" v-else>{{step.responses}}/{{step.questions.length}}</b-badge>
          </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div class="col-9">
      <div class=" text-center">
        <div class="" style="background-color:white; margin-top: 20px">
          <img :src="data.logo" alt="Logo de la compañia" class="logo" style="margin-top:10px;">
          <div class="row justify-content-center">
            <div class="col-12 col-md-11 text-center">
              <template v-if="!completed && !data.completed && data.round.active"> 
              <template v-for="(question, index) in currentQuestions">
              <simple-text :key="question.id" v-if="question.type === 'TEXT'" :question="question" :prev-id="prev_id"></simple-text>
              <radio :key="question.id" v-else-if="question.type === 'RADIO'" :question="question" :prev-id="prev_id"></radio>
              <check :key="question.id" v-else-if="question.type === 'CHECK'" :question="question" :prev-id="prev_id"></check>
              <nps :key="question.id" v-else-if="question.type === 'NPS'" :question="question" :prev-id="prev_id"></nps>
              <numeral :key="question.id" v-else-if="question.type === 'NUMERAL'" :question="question" :prev-id="prev_id"></numeral>
              </template>
                        
              <b-button @click="changeStep(-1)" variant="outline-primary" size="lg" class="mx-2 mt-5" v-if="active_step != 0">Atras</b-button>
              <b-button @click="sendData" variant="outline-primary" size="lg" class="mx-2 mt-5" :disabled="validate">Continuar</b-button>
              </template>
              <div class="text-center" v-if="completed">
                <h2>Encuesta contestada satisfactoriamente</h2>
                <h3>¡Muchas gracias por contestar nuestras preguntas!</h3>
              </div>
              <div class="stext-center" v-else-if="data.completed">
                <h2>La encuesta ya ha sido contestada.</h2>
                <h3>¡Muchas gracias por contestar nuestras preguntas!</h3>
              </div>
              <div class="text-center" v-else-if="!data.round.active">
                <h2>La encuesta a expirado.</h2>
              </div>

            </div>
          </div>
          <img :src="defaultLogo" alt="Logo knower.io" class="branding">
        </div>
        
      </div>
    </div>
  </div>  
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';
import axios from 'axios';
import SimpleText from './components/SimpleText.vue';
import Radio from './components/Radio.vue';
import Check from './components/Check.vue';
import Nps from './components/Nps.vue';
import Numeral from './components/Numeral.vue';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faCheckCircle, faCoffee } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faCoffee);
library.add(faUserSecret);
library.add(faCheckCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);

export default {
  components: {
    SimpleText,
    Radio,
    Check,
    Nps,
    Numeral
  },
  data: () => {
    return {
      question: {},
      completed: false,
      steps: null,
      active_step: 0,
      loader: true,
      prev_id: '',
      data: null,
      contact_id: null,
      email: null,
      round_id: null,
      survey_id: null,
      score: null,
      activeMenu: null,
      defaultLogo: process.env.LOGO_PATH,
      defaultWeb: process.env.URL_WEB
    };
  },
  computed: {
    currentStep: function () {
      return this.steps[this.active_step];  
    },
    currentQuestions: function () {
      return this.currentStep.questions; 
    },
    validate: function () {
      for (let index = 0; index < this.currentStep.questions.length; index++) {
        if (this.currentStep.questions[index].value === null && this.currentStep.questions[index].type !== 'RADIO' && this.currentStep.questions[index].type !== 'CHECK') {
          if (this.currentStep.questions[index].type === 'TEXT') {
            return false;
          }
          return true;
        }
      }
      return false;
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.contact_id = this.$route.params.contact_id;
      this.survey_id = this.$route.params.survey_id;
      this.round_id = this.$route.params.round_id;
      this.score = this.$route.params.score;
      this.email = this.$route.params.email;
      let url = 'survey/' + this.contact_id + '/' + this.round_id + '/' + this.email;
      if (this.score) {
        url += '/' + this.score;
      }
      axios.get(url).then(response => {
        this.data = response.data.data;
        this.steps = this.data.steps;
        /* set value to email click */ 
        this.checkIndex();
        if (this.steps[0].questions[0].value === null) {
          this.steps[0].questions[0].value = this.score;
        }
        this.loader = false;
        
      }).catch(error => {
        this.loader = false;
      });
    },
    changeStepMenu (index) {
      this.active_step = index;
      window.scrollTo(0, 0);
    },
    changeStep (i) {
      const aux = this.active_step + i;
      if (aux === this.data.steps.length) {
        this.completed = true;
      } else {
        this.active_step = aux;
      }
    },
    sendData () {
      let url = 'survey/' + this.data.survey.id + '/contact/' + this.data.contact.id + '/round/' + this.data.round.id + '/email/' + this.email;
      if (this.data.contact.test) {
        url += '/test';
      }
      const payload = {
        survey_id: this.survey_id,
        questions: this.currentQuestions,
        round_id: this.round_id,
        contact_id: this.data.contact.id,
        email_id: this.email,
      };
      this.currentStep.responses = this.currentQuestions.length;
      this.changeStep(1);
      window.scrollTo(0, 0);
      axios.post(url, payload).then(response => {

      }).catch(error => {
      });
      
    },
    checkIndex () {
      for (let index = 0; index < this.steps.length; index++) {
        for (let key = 0; key < this.steps[index]['questions'].length; key++) {
          if (this.steps[index]['questions'][key]['value'] === null) {
            if (this.steps[index]['questions'][key]['type'] === 'CHECK' || this.steps[index]['questions'][key]['type'] === 'RADIO') {
              if (this.steps[index]['questions'][key]['options_values'].length === 0) {
                this.active_step = index;
                return index;
              }
            } else {
              this.active_step = index;
              return index;
            }
          }
        }
      }
    },
    activeMenu2 (x) {
      if (x === this.active_step) {
        return true;
      }
      return false;
    }

  }
};
</script>
<style lang="css">
  .card-body{
    padding: 0px !important;
  }
  .activeStep{
    color:white !important;
    background-color: #1976d2 !important;
  }
  .list-group-item{
    border: none;
  }
  .borderMenu{
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
  a:hover {      
    border-color: #007bff;
  }
  .list-group-item.active {
    color: #000;
    background-color: #f0f2f4; 
    border-color: #007bff; 
  }
  body{
    background: #f0f2f4;
  }
</style>



// WEBPACK FOOTER //
// src/surveys/SurveyClimate.vue